var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_044-instagram",
    "data-name": "044-instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.818,
    height: 17.818,
    viewBox: "0 0 17.818 17.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_301",
    "data-name": "Trazado 301",
    d: "M10.887,5.838a5.041,5.041,0,1,0,5.041,5.041,5.04,5.04,0,0,0-5.041-5.041Zm0,8.312a3.272,3.272,0,1,1,3.272-3.272A3.271,3.271,0,0,1,10.887,14.15Z",
    transform: "translate(-1.975 -1.973)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_302",
    "data-name": "Trazado 302",
    d: "M12.582.057c-1.639-.076-5.7-.073-7.34,0A5.324,5.324,0,0,0,1.5,1.5C-.21,3.211.009,5.52.009,8.906c0,3.466-.193,5.721,1.494,7.409,1.72,1.719,4.062,1.494,7.409,1.494,3.433,0,4.618,0,5.832-.468,1.65-.641,2.9-2.116,3.018-4.766.077-1.64.073-5.7,0-7.34C17.614,2.108,15.936.211,12.582.057Zm2.595,15.124C14.054,16.3,12.5,16.2,8.89,16.2c-3.712,0-5.2.055-6.287-1.034-1.251-1.245-1.025-3.244-1.025-6.276,0-4.1-.421-7.056,3.7-7.267.946-.033,1.224-.045,3.605-.045l.033.022c3.956,0,7.06-.414,7.247,3.7.042.939.052,1.221.052,3.6,0,3.669.069,5.166-1.035,6.276Z",
    transform: "translate(0 -0.001)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 1.282,
    cy: 1.282,
    r: 1.282,
    transform: "translate(12.253 3.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3848d36be0d11bdc0db7c03b1265b1d7.svg";
export { ForwardRef as ReactComponent };